export const DISPLAY_FLEX_STYLES = {
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center'
};
